export const toggleFilters = () => {
  const switcher = document.querySelector(".filter__switcher");
  const switcherMobile = document.querySelector(".filter__switcher-mobile");
  const hideMobile = document.querySelector(".filter__hide-mobile");
  const wrapper = document.querySelector(".filter__wrapper");
  if (switcher) {
    switcher.addEventListener("click", () => {
      wrapper.classList.toggle("filter__wrapper--visible");
      switcher
        .querySelector("img")
        .classList.toggle("filter__switcher-img--active");
    });
  }
  if (switcherMobile) {
    switcherMobile.addEventListener("click", () => {
      wrapper.classList.toggle("filter__wrapper--mobile-visible");
    });
  }
  if (hideMobile) {
    hideMobile.addEventListener("click", () => {
      wrapper.classList.toggle("filter__wrapper--mobile-visible");
    });
  }
};
